<template>
<!-- 新闻列表 -->
    <div class="newslist">
        <!-- 分类标题 -->
        <div class="title">
            <div class="left">
                {{ cateName }}
            </div>
            <div class="right" @click="showMore">
                更多 >
            </div>
        </div>

        <!-- 新闻列表 -->
        <div class="newsbox">
            <div class="news" v-for="( item, index) in NewsList" :key="index">
                <div class="item"  @click="showNewsDetail( item )">
                    <!-- 带封面 -->
                    <div class="content" v-if="isPoster && index == 0 ">
                        <div class="imgbox">
                            <img :src="item.news_headpic" :class="isHover ? 'animate__animated animate__zoomIn' : '' "  v-if="item.news_headpic && item.news_headpic.indexOf('http') != -1"  alt="">
                            <img :src="$ImgUrl + item.news_headpic" :class="isHover ? 'animate__animated animate__zoomIn' : '' "   v-if="item.news_headpic && item.news_headpic.indexOf('http') == -1"  alt="">
                        </div>
                        <div class="info">
                            <div class="news_title" @mouseenter="isHover = true" @mouseleave="isHover = false" >
                                <span>{{ item.news_title }}</span>
                            </div>
                            <div class="news_content">
                                <span>{{ item.news_content }}</span>
                            </div>
                            <div class="news_more" @click="showMore">
                                查看更多 >
                            </div>
                        </div>
                    </div>

                    <!-- 不带封面 -->
                    <div class="list" v-else>
                        <div class="news_icon" v-if="showIcon">
                            <span class="iconfont icon-liebiao"></span>
                        </div>
                        <div class="news_title">
                            <el-popover trigger="hover" placement="top">
                                <p > {{ item.news_title }}</p>
                                <div slot="reference" class="name-wrapper">
                                    <p slot="reference" class="poper" :class="hoverIndex == index ? 'active_news ' : '' " @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = null" >{{ item.news_title }} </p>
                                </div>
                            </el-popover>
                        </div>
                        <div class="time">
                            {{ item.create_time }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isPoster: {  // 第一个数据是否显示封面
                type: Boolean,
                default: false,
            },
            size: {  // 显示的数据量
                type: Number,
                default: 5
            },
            cateName: {
                type: String,
                required: true,
            },
            cateId: {
                type: Number,
                required: true
            },
            showIcon: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                NewsList: [], // 新闻列表
                isHover: false,
                hoverIndex:null,
            }
        },
        computed: {
            cate_id () {
                return this.cateId
            }
        },
        mounted() {
            this.getNewsList()
        },
        methods: {
            // 获取新闻列表
            async getNewsList () {
                let { cate_id, size } = this 
                let res = await this.$axios.post("/lencon/pc/index/index_news_list", { cate_id, pageSize: size })
                if ( res.data.code == 1 ) {
                    this.NewsList = res.data.res
                } 
            },
            // 展示新闻详情
            showNewsDetail ( item ) {
                this.$router.push({
                    path: `/NewsDetail/${item.news_id}`,
                    query: {
                        cate_id: item.cate_id
                    }
                })
            },

            // 查看更多
            showMore () {
                this.$router.push({
                    path:"/moreNewsList",
                    query: {
                        cate_id: this.cate_id,
                        isSearch: 0,
                        keyword: "",
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.poper {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.active_news {
    color: #2767c4 ;
    font-weight: bold;
}
.newslist {
    width: 580px;
    box-sizing: border-box;
    .title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #2767c4 ;
        .left {
            font-size: 24px;
            color: #2767c4 ;
            font-weight: bold;
        }
        .right {
            font-size: 14px;
            color: #B3B3B3;
            cursor: pointer;
        }
    }
    .newsbox {
        width: 100%;
        box-sizing: border-box;
        padding-top: 20PX;
        .item {
            width: 100%;
            margin-bottom: 20PX;
            .content {
                display: flex;
                cursor: pointer;
                .imgbox {
                    width: 220px;
                    height: 130px;
                    img {
                        width: 220px;
                        height: 130px;
                    }
                }
                .info {
                    flex: 1;
                    margin-left: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .news_title {
                        font-size: 18px;
                        width: 340px;
                        font-weight: bold;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        span {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                    .news_content {
                        font-size: 16px;
                        color: #B3B3B3;
                        height: 80px;
                        span {
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                    .news_more {
                        font-size: 14px;
                        color: #B3B3B3;
                        cursor: pointer;
                    }
                }
            }

            .list {
                width: 100%;
                display: flex;
                align-items: center;
                font-size: 16px;
                cursor: pointer;
                .news_icon {
                    color: #2767c4 ;
                    width: 30px;
                }
                .time {
                    width: 100px;
                    text-align: right;
                    font-size: 14px;
                    color: #AEAEAE;
                }
                .news_title {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>